import api from './api'
import {prop} from 'ramda'

const paylocity = ($http) => {
  'ngInject'

  /**
   * Creates user account at Paylocity
   *
   * @param {string} user_id
   * @param {string} ssn (optional)
   */
  const createPaylocityAccount = (userId, ssn) => {
    return $http({
      method: 'POST',
      contentType: 'application/json',
      url: `${api.getBase()}/user/paylocity/create`,
      data: {
        user_id: userId,
        ssn: ssn
      }
    })
    .then(prop('data'))
  }

  /**
   * Synchronizes user account at Paylocity
   *
   * @param {string} user_id
   */
  const synchronizePaylocityAccount = (userId) => {
    return $http({
      method: 'POST',
      contentType: 'application/json',
      url: `${api.getBase()}/user/paylocity/synchronize`,
      data: {
        user_id: userId
      }
    })
    .then(prop('data'))
  }

  return {
    createPaylocityAccount,
    synchronizePaylocityAccount
  }
}

export default paylocity
